import { getUserLocationAPI } from "../../api/config/getUserLocation";

// Dedicated localStorage key for the IP-detected ISO-2 country. Kept SEPARATE
// from the shared `userLocation` global (which flows into socket/search/pixel
// payloads) so this phone-country feature has zero blast-radius elsewhere.
const GEO_COUNTRY_KEY = "_zenvoya_geo_country";

/** Returns the cached IP-detected ISO-2 country (e.g. "IN", "US"), or "". */
export function getCachedGeoCountryIso(): string {
  try {
    const value = localStorage.getItem(GEO_COUNTRY_KEY);
    return value ? value.trim().toUpperCase() : "";
  } catch {
    return "";
  }
}

function setCachedGeoCountryIso(iso: string): void {
  try {
    if (iso) localStorage.setItem(GEO_COUNTRY_KEY, iso);
  } catch {
    /* private mode / quota — ignore */
  }
}

/**
 * Detects the user's country (ISO-2) from their IP via the already-integrated
 * Radar geocode endpoint (`getUserLocationAPI` → GET /v1/geocode/ip; no permission
 * prompt) and caches it in localStorage. Used to auto-select the traveler phone
 * country code by browser LOCATION. Returns the ISO-2, or "" on any failure.
 *
 * Fire-and-forget from app init; the value is read synchronously later by
 * `resolveDefaultCountryDisplay` via `getCachedGeoCountryIso()`.
 */
export async function fetchAndCacheGeoCountry(accessJWT: string): Promise<string> {
  try {
    const data: any = await getUserLocationAPI(accessJWT);
    const iso = (data?.address?.countryCode || data?.countryCode || "")
      .toString()
      .trim()
      .toUpperCase();
    if (iso) setCachedGeoCountryIso(iso);
    return iso;
  } catch {
    return "";
  }
}
